import storage from '../common/utils/storage'

/**
 * Переводы для файла editor.config.js
 */
const T = {
    leftImage: {
        en: 'Left image',
        ru: 'Изображение слева',
    },
    rightImage: {
        en: 'Right image',
        ru: 'Изображение справа',
    },
    dividerColor: {
        en: 'Divider color',
        ru: 'Цвет разделителя',
    },
    marginWeb: {
        en: 'Margin (Web)',
        ru: 'Отступ (Web)',
    },
    feedbackAfterAnswers: {
        en: 'Feedback after answers',
        ru: 'Фидбэк после ответов',
    },
    questions: {
        en: 'Questions',
        ru: 'Вопросы',
    },
    cover: {
        en: 'Cover',
        ru: 'Обложка',
    },
    coverScreen: {
        en: 'Start screen',
        ru: 'Стартовый экран',
    },
    results: {
        en: 'Results',
        ru: 'Результаты',
    },
    userForm: {
        en: 'User Form',
        ru: 'Форма сбора данных',
    },
    showQuestionProgress: {
        en: 'Question progress',
        ru: 'Прогресс ответов',
    },
    backgroundColor: {
        en: 'Background color',
        ru: 'Цвет фона',
    },
    backgroundImage: {
        en: 'Background image',
        ru: 'Фоновое изображение',
    },
    chooseImage: {
        en: 'Choose Image',
        ru: 'Выберите изображение',
    },
    borderRadius: {
        en: 'Border radius',
        ru: 'Скругление углов',
    },
    borderWidth: {
        en: 'Border width',
        ru: 'Толщина обводки',
    },
    borderColor: {
        en: 'Border color',
        ru: 'Цвет обводки',
    },
    dropShadow: {
        en: 'Drop Shadow',
        ru: 'Тень',
    },
    blur: {
        en: 'Blur',
        ru: 'Размытие',
    },
    grayscale: {
        en: 'Grayscale',
        ru: 'Черно-белый режим',
    },
    openUrl: {
        en: 'Open Url',
        ru: 'Открыть ссылку',
    },
    icon: {
        en: 'Icon',
        ru: 'Иконка',
    },
    title: {
        en: 'Title',
        ru: 'Заголовок',
    },
    firstName: {
        en: 'First name',
        ru: 'Имя',
    },
    lastName: {
        en: 'Last name',
        ru: 'Фамилия',
    },
    email: {
        en: 'Email',
        ru: 'Email',
    },
    phone: {
        en: 'Phone',
        ru: 'Телефон',
    },
    linkPrivacyPolicy: {
        en: 'Link to your privacy policy',
        ru: 'Ссылка на вашу политику конфиденциальности',
    },
    optionBackground: {
        en: 'Option background',
        ru: 'Фон варианта ответа',
    },
    fontColor: {
        en: 'Font color',
        ru: 'Цвет текста',
    },
    fontSize: {
        en: 'Font size',
        ru: 'Размер текста',
    },
    dotSize: {
        en: 'Dot size',
        ru: 'Размер точек',
    },
    completionBackgroundColor: {
        en: 'Completion background color',
        ru: 'Цвет заполнения',
    },
    szTop: {
        en: 'Safe zone top',
        ru: 'Отступ сверху',
    },
    szLeft: {
        en: 'Safe zone left',
        ru: 'Отступ слева',
    },
    szRight: {
        en: 'Safe zone right',
        ru: 'Отступ справа',
    },
    szBottom: {
        en: 'Safe zone bottom',
        ru: 'Отступ снизу',
    },
    displayType: {
        en: 'Display type',
        ru: 'Поведение при масштабировании',
    },
    itsCorrectOption: {
        en: "It's correct option",
        ru: 'Это правильный ответ',
    },
    setAsCorrect: {
        en: 'Set as correct',
        ru: 'Назначить верным',
    },
    setAsIncorrect: {
        en: 'Set as incorrect',
        ru: 'Это неверный ответ',
    },
    sendToBack: {
        en: 'Send to back',
        ru: 'На задний план',
    },
    bringToFront: {
        en: 'Bring to front',
        ru: 'На передний план',
    },
    text: {
        en: 'Text',
        ru: 'Нумерация',
    },
    progressBar: {
        en: 'Progress bar',
        ru: 'Прогресс-бар',
    },
    stepBar: {
        en: 'Step bar',
        ru: 'Шаги',
    },
    dotsBar: {
        en: 'Dots bar',
        ru: 'Точки',
    },
    tidyUp: {
        en: 'Tidy up',
        ru: 'Подравнять',
    },
    flow: {
        en: 'Flow',
        ru: 'Показывать всегда',
    },
    decor: {
        en: 'Decor',
        ru: 'Обрезать как декор',
    },
    addHeading: {
        en: 'Add Heading',
        ru: 'Заголовок',
    },
    addParagraph: {
        en: 'Add paragraph, a block\nof text that you can edit',
        ru: 'Добавить параграф,\n текстовый блок',
    },
    addLink: {
        en: 'Add link',
        ru: 'Добавить ссылку',
    },
    addCaption: {
        en: 'Add caption. To sign pictures for example.',
        ru: 'Добавить описание.\nНапример, подпись к фотографии',
    },
    justImage: {
        en: 'Just image',
        ru: 'Изображение',
    },
    interactiveImage: {
        en: 'Interactive image',
        ru: 'Фото-ответ',
    },
    selectOptionHint1: {
        en: 'Select this option if you want to use images as answers.',
        ru: 'Выберите этот вариант, если хотите использовать изображение в качестве ответа',
    },
    navigation: {
        en: 'Navigation',
        ru: 'Навигация',
    },
    ctaButtons: {
        en: 'CTA buttons',
        ru: 'Действия',
    },
    share: {
        en: 'Share',
        ru: 'Соцсети',
    },
    textAnswers: {
        en: 'Text answers',
        ru: 'Текстовый ответ',
    },
    pictureAnswers: {
        en: 'Picture answers',
        ru: 'Фото-ответ',
    },
    textQuestion: {
        en: 'Text question',
        ru: 'Текстовый вопрос',
    },
    photoSlide: {
        en: 'Photo slide',
        ru: 'Фото-вопрос',
    },
    photoOptions: {
        en: 'Photo options',
        ru: 'Фото-ответы',
    },
    yourQuestion: {
        en: 'YOUR QUESTION',
        ru: 'ВАШ ВОПРОС',
    },
    option: {
        en: 'Option',
        ru: 'Ответ',
    },
    plainText: {
        en: 'Plain text',
        ru: 'Текст',
    },
    resultWithPicture: {
        en: 'Result with picture',
        ru: 'Результат с картинкой',
    },
    yourResult: {
        en: 'YOUR RESULT',
        ru: 'ВАШ РЕЗУЛЬТАТ',
    },
    tryAgain: {
        en: 'Try again',
        ru: 'Начать сначала',
    },
    hereIsDetailedDescriptionResult: {
        en: 'Here is a detailed description of the result.',
        ru: 'Здесь вы можете добавить подробное пояснение',
    },
    collageOnFinalScreen: {
        en: 'Collage on final screen',
        ru: 'Коллаж на финальном экране',
    },
    horizontal: {
        en: 'Horizontal',
        ru: 'Горизонтально',
    },
    vertical: {
        en: 'Vertical',
        ru: 'Вертикально',
    },
    centered: {
        en: 'Centered',
        ru: 'По центру',
    },
    final: {
        en: 'Final',
        ru: 'Результат',
    },
    slides: {
        en: 'Slides',
        ru: 'Слайды',
    },
    cardsIndent: {
        en: 'Cards indent',
        ru: 'Отступ между карточками',
    },
    playgroundRow: {
        en: 'Playground row',
        ru: 'Игровое поле',
    },
    updateCards: {
        en: 'Update cards',
        ru: 'Карточки Мемори',
    },
    loadCardsBackImage: {
        en: 'Load cards back image',
        ru: 'Рубашка карточек',
    },
    workPlace: {
        en: 'Workplace',
        ru: 'Игровое поле',
    },
    rankCards: {
        en: 'Rank cards',
        ru: 'Изображения на карточках',
    },
    highlightColorOfLeader: {
        en: 'Highligt color (leader)',
        ru: 'Подсветка (лидера)',
    },
    numberOfCards: {
        en: 'Number of cards',
        ru: 'Количество карточек',
    },
    phoneNumber: {
        en: 'Phone number',
        ru: 'Телефонный номер',
    },
    preFilledMessage: {
        en: 'Pre-filled message',
        ru: 'Сообщение',
    },
}

const LNG = storage.getValue('lng') ? storage.getValue('lng').split('-')[0] : 'en'
/**
 * Languages
 */
export function getTranslation(key) {
    return T[key][LNG]
}
